import {showDeleteConfirmation} from '@modules/common';
import {switchMap} from 'rxjs/operators';
import {BaseBloc} from '@core/utils/bloc';
import {Repository} from '@core/utils/repository';
import {handleMessage, requestMessage} from '@business/messages';
import {
    CalendarEventId,
} from '@business/entities/calendar_event';
import {CalendarEventCommentId, CalendarEventCommentResponse} from "@business/entities/calendar_event_comment";
import {CalendarEventCommentAPI} from "@business/api/calendar_event_comments";

export class EventCommentBloc extends BaseBloc {
    private readonly commentsRepo = new Repository<CalendarEventCommentResponse>({
        getItemId: comment => comment.id,
    });

    readonly comments$ = this.commentsRepo.items$;

    onReset() {
        this.commentsRepo.reset();
    }

    fetchEventComments = (eventId: CalendarEventId) => {
        return CalendarEventCommentAPI.fetchEventComments(eventId).pipe(
            this.commentsRepo.ops.reset(),
            handleMessage({error: requestMessage('fetch_calendar_event_comments_error')}),
        );
    };

    createEventComment = (eventId: CalendarEventId, message: string) => {
        return CalendarEventCommentAPI.createEventComment(eventId, message).pipe(
            this.commentsRepo.ops.addOne(item => item),
            handleMessage({
                type: requestMessage('create_calendar_event_comment'),
            }),
        );
    };

    updateEventComment = (commentId: CalendarEventCommentId, message: string) => {
        return CalendarEventCommentAPI.updateEventComment(commentId, message).pipe(
            this.commentsRepo.ops.upsertOne(item => ({item})),
            handleMessage({
                type: requestMessage('update_calendar_event_comment'),
            }),
        );
    };

    deleteEventComment = (commentId: CalendarEventCommentId) => {
        return showDeleteConfirmation('Delete Event Comment', 'Do you really want to remove this comment?').pipe(
            switchMap(() => CalendarEventCommentAPI.deleteEventComment(commentId)),
            this.commentsRepo.ops.removeOne(() => commentId),
            handleMessage({
                type: requestMessage('delete_calendar_event_comment'),
            }),
        );
    };
}
